import { useSession } from './useSession.js';

export function useSignOut(): () => Promise<void> {
  const session = useSession();
  return async () => {
    try {
      await session.signOut();
    } catch (error) {
      // The failure screen offers the retry; any other rejection has no visible state.
      if (session.state.kind === 'signOutFailed') return;
      throw error;
    }
    window.location.replace('/login');
  };
}
